"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var errors_1 = require("@ledgerhq/errors");
var bip32_path_1 = __importDefault(require("bip32-path"));
var CLA = 0xe0;
var INS = {
    GET_PUBLIC_KEY: 0x02,
    SIGN_TRANSACTION: 0x04
};
var STATUS = {
    OK: 0x9000,
    USER_CANCEL: 0x6985
};
/** Hedera BOLOS API */
var Hedera = /** @class */ (function () {
    function Hedera(transport, scrambleKey) {
        if (scrambleKey === void 0) { scrambleKey = "BOIL"; }
        this.transport = transport;
        transport.decorateAppAPIMethods(this, ["getPublicKey"], scrambleKey);
    }
    /**
     * Get a Hedera public key for a given BIP-32 path.
     *
     * Note that this does not return an address, nor is an account
     * address derivable from a public key on the Hedera network.
     *
     * @param path a path in BIP-32 format
     * @return the public key
     */
    Hedera.prototype.getPublicKey = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            var bipPath, serializedPath, p1, p2, response, returnCodeBytes, returnCode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bipPath = bip32_path_1["default"].fromString(path).toPathArray();
                        serializedPath = this._serializePath(bipPath);
                        p1 = 0x01;
                        p2 = 0x00;
                        return [4 /*yield*/, this.transport.send(CLA, INS.GET_PUBLIC_KEY, p1, p2, serializedPath)];
                    case 1:
                        response = _a.sent();
                        returnCodeBytes = response.slice(-2);
                        returnCode = (returnCodeBytes[0] << 8) | returnCodeBytes[1];
                        if (returnCode === STATUS.USER_CANCEL) {
                            throw new errors_1.UserRefusedAddress();
                        }
                        return [2 /*return*/, response.slice(0, 32).toString("hex")];
                }
            });
        });
    };
    // TODO: the BOLOS app does not support anything but index #0 for signing transactions
    Hedera.prototype.signTransaction = function (transaction) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, p1, p2, response, returnCodeBytes, returnCode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = Buffer.alloc(4 + transaction.length);
                        payload.writeUInt32LE(0);
                        payload.fill(transaction, 4);
                        p1 = 0x00;
                        p2 = 0x00;
                        return [4 /*yield*/, this.transport.send(CLA, INS.SIGN_TRANSACTION, p1, p2, payload)];
                    case 1:
                        response = _a.sent();
                        returnCodeBytes = response.slice(-2);
                        returnCode = (returnCodeBytes[0] << 8) | returnCodeBytes[1];
                        if (returnCode === STATUS.USER_CANCEL) {
                            throw new errors_1.UserRefusedOnDevice();
                        }
                        return [2 /*return*/, response.slice(0, -2)];
                }
            });
        });
    };
    /**
     * Serialize a BIP path to a data buffer, intended for
     * consumption by the Hedera BOLOS.
     *
     * @private
     */
    Hedera.prototype._serializePath = function (path) {
        var data = Buffer.alloc(1 + path.length * 4);
        path.forEach(function (segment, index) {
            data.writeUInt32BE(segment, 1 + index * 4);
        });
        return data;
    };
    return Hedera;
}());
exports["default"] = Hedera;
//# sourceMappingURL=index.js.map